module.exports = __webpack_public_path__ + "static/media/information-icon2-.f78d3b00.jpg";